module.exports = __webpack_public_path__ + "img/halfmark-black.5c98aa76.svg";